import { useLocation } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const useCurrentAutomationRoute = () => {
  const { pathname } = useLocation()
  const { navigation } = useNavigation()

  const isHistory = pathname.includes('history')

  return isHistory
    ? navigation.settings.automations.id.history
    : navigation.settings.automations.id.details
}
